import "./modal-swiper.js";

(function () {
  "use strict";

  if (!customElements.get("product-video-reels")) {
    class ProductVideoReels extends HTMLElement {
      constructor() {
        super();
        this.swiperContainer = this.querySelector(".wt-slider__container");
        this.modalOverlay = null;
        this.slides = []; // { src, cardHTML, item, mediaType }
        this.currentIndex = 0;
        this.pageBody = document.querySelector("body");
        this.bodyActiveModalClass = "video-reels-modal-opened";
      }

      connectedCallback() {
        this.checkInterval = setInterval(() => this.checkSwiperInit(), 500);

        const ds = this.dataset;

        this.options = {
          autoAdvanceOnEnd: ds.autoAdvanced === "true",
          showUnmute: ds.showUnmute === "true",
          showPlayPause: ds.showPlayPause === "true",
          showQuickAdd: ds.showQuickAdd === "true",
          threshold: 5,
        };
      }

      disconnectedCallback() {
        clearInterval(this.checkInterval);
      }

      checkSwiperInit() {
        if (
          this.swiperContainer &&
          this.swiperContainer.classList.contains("swiper-initialized")
        ) {
          clearInterval(this.checkInterval);
          this.initSlides();
          this.initItemClicks();
        }
      }

      initSlides() {
        this.slides = Array.from(
          this.querySelectorAll(".wt-product-video-reels__item"),
        ).map((item) => {
          const videoEl = item.querySelector("video");
          const stillWrap = item.querySelector(".wt-product-video-reels__still-wrap");
          let src = "";
          let mediaType = "video";

          if (videoEl) {
            const vsrc =
              videoEl.querySelector("source")?.src || videoEl.currentSrc || "";
            if (vsrc) {
              src = vsrc;
              mediaType = "video";
            } else if (stillWrap) {
              src = stillWrap.dataset.modalImage || "";
              mediaType = "image";
            }
          } else if (stillWrap) {
            src = stillWrap.dataset.modalImage || "";
            mediaType = "image";
          }

          const cardEl = item.querySelector(".shoppable-product-card");

          if (!this.options.showQuickAdd)
            cardEl?.classList.add("shoppable-product-card--disable-quick-add");

          return { src, cardHTML: cardEl?.outerHTML || "", item, mediaType };
        });
      }

      initItemClicks() {
        this.slides.forEach((slide, idx) => {
          const opensModal = slide.mediaType === "video" && slide.src;
          if (!opensModal) return;

          slide.item.style.cursor = "pointer";
          slide.item.addEventListener("click", () => this.openModalAt(idx));
        });
      }

      /** Full-screen modal only for video slides; image-only tiles stay in the carousel. */
      openModalAt(index) {
        const modalSlides = this.slides.filter(
          (s) => s.mediaType === "video" && s.src,
        );
        if (!modalSlides.length) return;

        let initialSlide = 0;
        for (let i = 0; i < index; i++) {
          if (this.slides[i].mediaType === "video" && this.slides[i].src) {
            initialSlide++;
          }
        }

        this.currentIndex = index;
        this.modal = document.createElement("modal-swiper");
        this.modal.slides = modalSlides;
        this.modal.config = {
          initialSlide,
          slidesPerView: 1,
          centeredSlides: true,
          direction: "vertical",
          loop: modalSlides.length > 1,
          navigation: {
            nextEl: ".video-reels-modal__nav--next",
            prevEl: ".video-reels-modal__nav--prev",
          },
          pagination: false,
          ...this.options,
        };
        this.modal.open();
      }

      navigate(delta) {
        this.currentIndex =
          (this.currentIndex + delta + this.slides.length) % this.slides.length;
        const { src, cardHTML, mediaType } = this.slides[this.currentIndex];
        if (!this.modalOverlay) return;
        const activeSlide = this.modalOverlay.querySelector(
          ".swiper-slide-active",
        );
        const vid = activeSlide?.querySelector("video");
        const still = activeSlide?.querySelector(".video-reels-modal__still");
        if (vid && (mediaType || "video") !== "image") {
          vid.pause();
          vid.src = src;
          vid.load();
          vid.play();
        } else if (still) {
          still.src = src;
        }
        const cardEl = activeSlide?.querySelector(".shoppable-product-card");
        if (cardEl && cardHTML) cardEl.outerHTML = cardHTML;
      }

      closeModal() {
        if (!this.modalOverlay) return;
        this.modalOverlay.querySelectorAll("video").forEach((v) => {
          v.pause();
          v.currentTime = 0;
        });
        this.modalOverlay.remove();
        this.modalOverlay = null;
        this.pageBody.classList.remove(this.bodyActiveModalClass);
      }
    }

    customElements.define("product-video-reels", ProductVideoReels);
  }
})();
